import React, { memo, useCallback, useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";

import { onDragEndMultiple } from "../../helpers";
import { useHubSnackBar } from "../../hooks";
import SchedulerColumn from "./SchedulerColumn";
import { computePlaceholder } from "./helper";

export const SchedulerDragDrop = ({
  elements,
  view,
  targetDate,
  onChange,
  onDragUpdate,
}) => {
  const { addSnackbarError } = useHubSnackBar();
  const [isActive, setIsActive] = useState(false);
  const [placeholderProps, setPlaceholderProps] = useState(null);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent =
      "body.hub-dragging .MuiTooltip-popper { display: none !important; }";
    document.head.appendChild(style);
    return () => style.remove();
  }, []);

  const handleDragStart = useCallback(() => {
    setIsActive(true);
    document.body.classList.add("hub-dragging");
  }, []);

  const handleDragUpdate = useCallback(
    (update) => {
      setIsActive(!!update?.destination);
      setPlaceholderProps(computePlaceholder(update));
      onDragUpdate?.(update);
    },
    [onDragUpdate],
  );

  const handleDragEnd = useCallback(
    (result) => {
      setIsActive(false);
      setPlaceholderProps(null);
      onDragUpdate?.(null);
      document.body.classList.remove("hub-dragging");
      onDragEndMultiple(result, {
        elements,
        onChange,
        addSnackbarError,
      });
    },
    [elements, onChange, addSnackbarError, onDragUpdate],
  );

  return (
    <div className="HubDroppablesContainer-root">
      <DragDropContext
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        onDragUpdate={handleDragUpdate}
      >
        {elements.map((week) => (
          <SchedulerColumn
            key={week.id}
            week={week}
            view={view}
            targetDate={targetDate}
            isActive={isActive}
            placeholderProps={placeholderProps}
          />
        ))}
      </DragDropContext>
    </div>
  );
};

export default memo(SchedulerDragDrop);
